/**
 * Transforms backend CasinoOddsDTO into the shape our casino components expect.
 * Called once inside createSocket's casino subscribe callback so individual
 * game components need zero changes.
 */

/**
 * Parse the backend card string into an array-of-arrays for CardDrawer.
 * Card string format: "KS2H" → each card is rank+suit (rank can be "10").
 * Returns e.g. [["KS","2H"]] or [[]] if empty.
 */
export function parseCardString(cardStr) {
  if (!cardStr || typeof cardStr !== "string") return [[]];

  const cards = [];
  let i = 0;
  while (i < cardStr.length) {
    // Rank can be "10" (2 chars) or single char (A,2-9,J,Q,K)
    let rank;
    if (cardStr[i] === "1" && cardStr[i + 1] === "0") {
      rank = "10";
      i += 2;
    } else {
      rank = cardStr[i];
      i += 1;
    }
    // Suit is always a single char (S, H, D, C)
    const suit = cardStr[i] || "";
    i += 1;
    cards.push(rank + suit);
  }

  return [cards];
}

/**
 * Transform a single CasinoOddsDTO message from the backend WebSocket
 * into the legacy shape that all casino game components read.
 *
 * Backend shape:
 *   { marketId, autoTime, data: { card, sub: [{ nat, b, l, sid, gstatus, min, max }] } }
 *
 * Component-expected shape:
 *   { marketId, autoTime, cards, oddDetailsDTOS: [{ runnerName, back1, lay1, selectionId, status, minBet, maxBet }] }
 *
 * Passthrough: if `data.sub` is absent, returns payload unchanged (backward compat).
 */
export function transformCasinoOddsDTO(payload) {
  if (!payload?.data?.sub) return payload;

  const { data, ...rest } = payload;

  return {
    ...rest,
    cards: parseCardString(data.card),
    oddDetailsDTOS: data.sub.map((runner) => ({
      runnerName: runner.nat || "",
      back1: runner.b != null ? runner.b : null,
      lay1: runner.l != null ? runner.l : null,
      selectionId: String(runner.sid),
      status: runner.gstatus || "SUSPENDED",
      minBet: runner.min,
      maxBet: runner.max,
    })),
  };
}
